import React from "react";

import { SkeletonRegion } from "../../../components/Skeleton";

const Shimmer = ({ width, height = 12, radius }) => (
  <span
    className="sy-flow-shimmer"
    style={{ width, height, ...(radius ? { borderRadius: radius } : null) }}
  />
);

const LineSkeleton = ({ specs = 2 }) => (
  <li className="sy-cart-line">
    <span className="sy-cart-line-media" />

    <div className="sy-cart-line-main">
      <div className="sy-cart-line-text">
        <Shimmer width="62%" height={15} />

        <span className="sy-cart-specs">
          {Array.from({ length: specs }, (_, index) => (
            <Shimmer key={index} width={index ? 74 : 96} height={20} radius="999px" />
          ))}
        </span>
      </div>
    </div>

    <div className="sy-cart-line-foot">
      <Shimmer width={104} height={36} radius="999px" />
      <Shimmer width={68} height={16} />
    </div>
  </li>
);

const SupplierCardSkeleton = ({ lines = 2 }) => (
  <section className="sy-flow-card sy-cart-supplier">
    <header className="sy-cart-supplier-head">
      <span className="sy-cart-logo" />

      <div className="sy-cart-supplier-body">
        <Shimmer width={168} height={15} />
        <Shimmer width={112} height={12} />
      </div>
    </header>

    <ul className="sy-cart-lines">
      {Array.from({ length: lines }, (_, index) => (
        <LineSkeleton key={index} specs={index ? 1 : 3} />
      ))}
    </ul>
  </section>
);

export const CartPageSkeleton = () => (
  <SkeletonRegion label="Loading your cart" className="sy-cart-skeleton">
    <div className="sy-flow-grid">
      <div className="sy-flow-main">
        <SupplierCardSkeleton lines={2} />
        <SupplierCardSkeleton lines={1} />
      </div>

      <div className="sy-flow-rail">
        <aside className="sy-flow-card">
          <div className="sy-flow-card-head">
            <Shimmer width={136} height={15} />
          </div>

          <div className="sy-flow-card-body sy-cart-skeleton-summary">
            <Shimmer width="100%" height={13} />
            <Shimmer width="100%" height={13} />
            <Shimmer width="70%" height={20} />
            <Shimmer width="100%" height={46} radius="12px" />
          </div>
        </aside>
      </div>
    </div>
  </SkeletonRegion>
);

export default CartPageSkeleton;
